import {useEffect, useRef} from "react";

export function useDeepCompareEffect(callback: () => void, dependencies: any[]) {
    const prevDeps = useRef<string | null>(null);

    useEffect(() => {
        const dependenciesString = JSON.stringify(dependencies);
        if(prevDeps.current !== dependenciesString) {
            prevDeps.current = dependenciesString;
            callback();
        }
    }, [callback, dependencies]);
}